module.exports = __webpack_public_path__ + "staticcomp/img/content_1.14f5207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/9/content_1.jpg
// module id = bmHX
// module chunks = 39